import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HolidayBalance {
  id: number;
  totalDays: number;
  daysTaken: number;
  daysPending: number;
  daysRemaining: number;
  notes?: string;
  createdAt: string;
  partner: {
    id: number;
    person: {
      firstName: string;
      lastName: string;
      secondLastName?: string;
    };
  };
  holidayPeriod: {
    id: number;
    startYear: number;
    endYear: number;
    description?: string;
  };
}

interface HolidayBalancesState {
  balances: HolidayBalance[];
  total: number;
  page: number;
  limit: number;
  query: string;
  sortBy: string;
  defaultSort: string;
  loading: boolean;
}

const initialState: HolidayBalancesState = {
  balances: [],
  total: 0,
  page: 0,
  limit: 50,
  query: '',
  sortBy: 'createdAt',
  defaultSort: 'desc',
  loading: false,
};

const holidayBalancesSlice = createSlice({
  name: 'holidayBalances',
  initialState,
  reducers: {
    setBalances: (state, action: PayloadAction<HolidayBalance[]>) => {
      state.balances = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<string>) => {
      state.defaultSort = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetBalances: (state) => {
      state.balances = [];
      state.total = 0;
      state.page = 0;
      state.query = '';
    },
  },
});

export const {
  setBalances,
  setTotal,
  setPage,
  setLimit,
  setQuery,
  setSortBy,
  setDefaultSort,
  setLoading,
  resetBalances,
} = holidayBalancesSlice.actions;

export default holidayBalancesSlice.reducer;
